import { useRef } from 'react'
import { Color, AdditiveBlending, BackSide } from 'three'

import { folder, useControls } from 'leva'

import '../../glow-shader-material/shader-material'

const GlowMesh = function (props: any) {
  const glowRef = useRef<any>(null)

  const { pVal, cVal, color } = useControls({
    glow: folder({
      pVal: { value: 5.5, max: 10, min: 0 },
      cVal: { value: 0.08, max: 2, min: 0 },
      color: { value: '#4a90e2' },
    }),
  })

  return (
    <mesh ref={glowRef} {...props}>
      <sphereGeometry args={[3.75, 40, 40]}></sphereGeometry>
      {/*@ts-ignore */}
      <glowShaderMaterial
        attach="material"
        c={cVal}
        p={pVal}
        glowColor={new Color(color)}
        transparent={true}
        depthWrite={false}
        blending={AdditiveBlending}
        side={BackSide}
      />
    </mesh>
  )
}

export default GlowMesh
